import { FunctionComponent } from "react";

import { Link, Stack, Text, TooltipHost } from "@bps/fluent-ui";
import { useTenantQuery } from "@libs/api/gateways/plt/plt-gateway.hooks";

interface TenantLinkProps {
  tenantId: string;
}
export const TenantLink: FunctionComponent<TenantLinkProps> = ({
  tenantId
}) => {
  const { data: tenant } = useTenantQuery(tenantId, { enabled: !!tenantId });

  // Audit events without a tenant (system-level) have no tenantId — don't query
  // or render a broken /tenants/null link (which also poisons the tenant cache).
  if (!tenantId) {
    return null;
  }

  return (
    <TooltipHost
      content={
        <Stack horizontal tokens={{ childrenGap: 4 }}>
          <Text bold>Application:</Text>
          <Text>{tenant?.application}</Text>
        </Stack>
      }
    >
      <Link href={`/tenants/${tenantId}`} target="_blank">
        {tenant?.name}
      </Link>
    </TooltipHost>
  );
};
